import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { HorizontalLine } from "./HorizontalLineBlock";
import { defaultData } from "./HorizontalLineDefaultData";
import { meta } from "./HorizontalLineMetaData";

export const HorizontalLineBlock: BlockExport = {
  type: "component",
  Block: HorizontalLine,
  defaultData,
  imagePreview: {
    type: "icon",
    name: "24-horizontal-line",
    size: 24,
  },
  meta,
};
